export default __webpack_public_path__ + "static/omar-kreidly-0fd4f18fc22986bc00a20c22398cfe31.png";